
export const getAndCheckTokenCaptCha = async (executeRecaptcha, action) => {
  try {
   if (!executeRecaptcha) {
      return null
    }
    const xRecaptchaToken = await executeRecaptcha(action);
    if (!xRecaptchaToken) {
      return null
    }
    return xRecaptchaToken 
  } catch (error) {
    console.log(error)
    return null
  }
}
